// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-block[data-v-a6daf612] {\n  border: 1px dashed #6e478f;\n  background-color: #e8ceff;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
